<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <p>{{ t("adminClassificationLauncher.createPlan.description") }}</p>
  <PrimeInputGroup>
    <PrimeInputGroupAddon>plan-</PrimeInputGroupAddon>
    <PrimeInputText
      v-model="newPlanName"
      :placeholder="t('adminClassificationLauncher.createPlan.placeholder')"
      :aria-label="t('adminClassificationLauncher.createPlan.placeholder')"
      aria-required="true"
      @keyup.enter="createPlan"
    />
    <PrimeInputGroupAddon>.json</PrimeInputGroupAddon>
  </PrimeInputGroup>
  <div class="create-plan-actions">
    <PrimeButton
      :label="t('adminClassificationLauncher.createPlan.cancel')"
      severity="secondary"
      text
      @click="emit('cancel')"
    />
    <PrimeButton
      :label="t('adminClassificationLauncher.createPlan.button')"
      icon="ri-add-line"
      :disabled="!newPlanName"
      @click="createPlan"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import PrimeButton from "primevue/button";
import PrimeInputText from "primevue/inputtext";
import PrimeInputGroup from "primevue/inputgroup";
import PrimeInputGroupAddon from "primevue/inputgroupaddon";

const emit = defineEmits(["create-plan", "cancel"]);

const toast = useToast();
const { t } = useI18n();

const newPlanName = ref("");

const createPlan = () => {
  if (!newPlanName.value || !newPlanName.value.trim()) {
    toast.add({
      severity: "warn",
      summary: t("adminClassificationLauncher.toast.invalidName.summary"),
      detail: t("adminClassificationLauncher.toast.invalidName.detail"),
      life: 3000,
    });
    return;
  }
  const filename = `plan-${newPlanName.value.trim()}.json`;
  emit("create-plan", filename);
};
</script>

<style lang="scss" scoped>
.create-plan-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
}
</style>
